/* Header battle — fermeture du menu burger (Escape / clic extérieur / clic lien) */
(function () {
  const drawer = document.getElementById('HeaderBattleDrawer');
  if (!drawer) return;

  const close = () => drawer.removeAttribute('open');

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.hasAttribute('open')) {
      close();
      drawer.querySelector('summary').focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (drawer.hasAttribute('open') && !drawer.contains(event.target)) close();
  });

  drawer.querySelectorAll('.header-battle__drawer-link').forEach((link) => {
    link.addEventListener('click', close);
  });
})();
